import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
export const ProfileAvatar = ({ fullname, size }) => {
    const [initials, setInitials] = useState();
    const cssClass = "user-initials " + size;
    useEffect(() => {
        var _a, _b;
        if (fullname !== undefined) {
            const userInitials = fullname.split(" ");
            setInitials(((((_a = userInitials[0]) === null || _a === void 0 ? void 0 : _a.charAt(0)) || "") + (((_b = userInitials[1]) === null || _b === void 0 ? void 0 : _b.charAt(0)) || "").toUpperCase()));
        }
    }, [fullname]);
    return _jsx("div", Object.assign({ className: cssClass }, { children: _jsx("div", Object.assign({ className: "user-initials__text" }, { children: initials })) }));
};
